import { useMemo, useState } from "react";
import Reveal from "@/pages/home/components/Reveal";
import SectionTitle from "@/pages/home/components/SectionTitle";
import { topics, topicGroups } from "@/mocks/home";

const groupTone: Record<string, string> = {
  入口: "bg-primary-100 text-primary-800",
  排查: "bg-accent-100 text-accent-800",
  使用: "bg-secondary-100 text-secondary-900",
  安全: "bg-background-200 text-foreground-800",
};

export default function TopicWall() {
  const [group, setGroup] = useState("全部");

  const list = useMemo(
    () => (group === "全部" ? topics : topics.filter((t) => t.group === group)),
    [group]
  );

  return (
    <section id="topic" className="bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="话题墙"
            title="大家最近都在搜这些"
            desc="按主题分组的访问话题，热度越高说明遇到的人越多。点一下分组，看看同类问题里还有哪些你没注意到的细节。"
          />
        </Reveal>

        <Reveal>
          <div className="mt-8 flex flex-wrap gap-2">
            {topicGroups.map((g) => (
              <button
                key={g}
                type="button"
                onClick={() => setGroup(g)}
                className={`whitespace-nowrap rounded-full px-1 py-1 transition-colors ${
                  group === g ? "bg-primary-500" : "bg-background-200/70 hover:bg-background-300/70"
                }`}
              >
                <span
                  className={`block rounded-full px-4 py-1.5 text-sm font-medium ${
                    group === g ? "text-background-50" : "text-foreground-700"
                  }`}
                >
                  {g}
                </span>
              </button>
            ))}
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((topic, index) => (
            <Reveal key={topic.name} delay={index * 45}>
              <div className="group flex h-full items-center justify-between gap-4 rounded-xl border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300">
                <div className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-100 text-primary-600">
                    <i className="ri-hashtag text-lg" aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="font-heading text-sm font-bold text-foreground-950">{topic.name}</p>
                    <span className={`mt-1 inline-block rounded-full px-2 py-0.5 text-[10px] font-medium ${groupTone[topic.group]}`}>
                      {topic.group}
                    </span>
                  </div>
                </div>
                <div className="text-right">
                  <p className="font-heading text-lg font-bold text-foreground-900">{topic.heat}</p>
                  <p className="text-[10px] text-foreground-500">讨论热度</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}